import React, { useContext, useEffect, useState, useRef } from "react";

import "./LanguageSelector.css";

import { CurrentLanguageContext } from "../../../Context/CurrentLanguageContext/CurrentLanguageContext";
import { useQueryString } from "../../../Hooks/useQueryString";
import { Icon } from "../../Icon/Icon";
import { useOutsideClick } from "../../../utils/useOutsideClick";
import { LanguageSelectorOption } from "./LanguageSelectorOption";
import { knownLanguages } from "../../../knownLanguages";
import { head } from "lodash";

export const LanguageSelector = () => {
  const queryParams = useQueryString();
  const { currentLanguage, handleChangeLanguage, setMethod } = useContext(
    CurrentLanguageContext
  );
  const ref = useRef(null);
  const [dropdown, setDropdown] = useState(false);

  useEffect(() => {
    const browserLang =
      navigator.language && head(navigator.language.split("-"));

    const queryLang = queryParams.get("lang") || browserLang;

    if (
      queryLang &&
      queryLang !== currentLanguage &&
      setMethod === "automatic"
    ) {
      handleChangeLanguage(queryLang);
    }
  });

  useOutsideClick(ref, () => setDropdown(false));

  return (
    <div className="LanguageSelector" ref={ref}>
      <div
        className="LanguageSelector__current-language"
        onClick={() => setDropdown(!dropdown)}
      >
        <p>{currentLanguage}</p>
        <div className="LanguageSelector__icon">
          <Icon name="iconDropdown" width={12} />
        </div>
      </div>
      {dropdown && (
        <div className="LanguageSelector__options">
          {knownLanguages.map((opt) => (
            <LanguageSelectorOption
              key={opt.value}
              option={opt}
              isActive={opt.value === currentLanguage}
              onClick={() => {
                handleChangeLanguage(opt.value, "manual");
                setDropdown(!dropdown);
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};
